class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.isDragging = false;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.handle = this.querySelector('.image-comparison__handle');

    if (!this.handle) return;

    this.handle.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);

    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.handle?.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);

    this.removeEventListener('click', this.onClick);
  }

  onPointerDown(event) {
    this.isDragging = true;
    this.setPointerCapture?.(event.pointerId);
    this.updatePosition(event.clientX);
  }

  onPointerMove(event) {
    if (!this.isDragging) return;

    event.preventDefault();
    this.updatePosition(event.clientX);
  }

  onPointerUp(event) {
    this.isDragging = false;
    this.releasePointerCapture?.(event.pointerId);
  }

  onClick(event) {
    this.updatePosition(event.clientX);
  }

  updatePosition(clientX) {
    const rect = this.getBoundingClientRect();
    let position = ((clientX - rect.left) / rect.width) * 100;

    position = Math.max(0, Math.min(100, position));

    this.style.setProperty('--image-comparison-position', `${position}%`);
  }
}

if (!customElements.get('image-comparison')) {
  customElements.define('image-comparison', ImageComparison);
}